import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import isObject from 'lodash/isObject';

import MovableByMouse from '@Hooks/MovableByMouse';

const savedCoordinatesMap = {};

export function movableMouseToStyle(newRefCoordinates, saveCoordinatesKey) {
  const coordinates = newRefCoordinates
    ? (({ x, y }) => ({ x, y }))(newRefCoordinates)
    : saveCoordinatesKey && savedCoordinatesMap[saveCoordinatesKey];

  if (saveCoordinatesKey && coordinates) {
    savedCoordinatesMap[saveCoordinatesKey] = coordinates;
  }

  return isObject(coordinates)
    ? {
        top: `${coordinates.y}px`,
        left: `${coordinates.x}px`,
        transform: 'initial',
        transition: 'none',
      }
    : undefined;
}

export const createMousedownEventValidator = (baseDialogLayoutAllowed) => (e) => {
  const { target } = e;
  const baseLayoutHeaderClicked = Boolean(target.closest('.base-dialog-layout-header-wrapper'));

  if (baseLayoutHeaderClicked) {
    return true;
  }

  return baseDialogLayoutAllowed && target.classList.contains('base-dialog-layout');
};

export default function BaseDialogLayoutMovableHoc(Component) {
  function BaseDialogLayoutMovableHocWrapper({ id, movable = true, resizable = false, movableSaveCoordinates, className, ...otherProps }) {
    const validateMousedownEvent = useMemo(() => createMousedownEventValidator(!resizable), [resizable]);

    if (!movable) {
      return (
        <Component
          id={id}
          className={className}
          movable={movable}
          resizable={resizable}
          movableSaveCoordinates={movableSaveCoordinates}
          {...otherProps}
        />
      );
    }

    return (
      <MovableByMouse validateMousedownEvent={validateMousedownEvent}>
        {(refForMovable, movableMouse, newRefCoordinates) => {
          const style = movableMouseToStyle(newRefCoordinates, movableSaveCoordinates && id);
          return (
            <Component
              {...otherProps}
              id={id}
              movable={movable}
              resizable={resizable}
              movableSaveCoordinates={movableSaveCoordinates}
              ref={refForMovable}
              className={classnames(className, 'base-dialog-layout-movable')}
              style={style}
            />
          );
        }}
      </MovableByMouse>
    );
  }

  BaseDialogLayoutMovableHocWrapper.propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    movable: PropTypes.bool,
    resizable: PropTypes.bool,
    movableSaveCoordinates: PropTypes.bool,
  };

  return BaseDialogLayoutMovableHocWrapper;
}
